import { useEffect } from 'react';
import { SelectedProduct, ProductType } from '../common/CommonTypes';
import { useNavigate, useLocation } from 'react-router';
import { RoutePaths } from '../../Constants/Common';
import { useAppSelector } from 'state/hooks';

type LocationState = {
    product: ProductType;
    productRoute: string;
};

export const useSelectedProduct = (): SelectedProduct => {
    const location = useLocation();
    const { product: locationStateProduct, productRoute } =
        location.state ?? ({} as LocationState);
    const navigate = useNavigate();
    const policy = useAppSelector((s) => s.vehicles.selectedPolicy);

    const product = locationStateProduct ?? policy; // TODO: get rid of locationStateProduct

    useEffect(() => {
        if (product === undefined) {
            navigate(RoutePaths.Product);
        }
    }, []);

    return { product, productRoute };
};
